import { useMsal } from '@azure/msal-react'
import { PText, PHeadline, PMarque, PFlex } from '@porsche-design-system/components-react'
import clsx from 'clsx'
import React from 'react'

import { NavLink, useLocation } from 'react-router-dom'

import { TEXTS } from '../../config/texts'
import { PortalContext } from '../../utils/PortalContext'

import styles from './navigation.module.css'

const ENV_LABEL = process.env.REACT_APP_ENV_LABEL || ''

export default function Navigation() {
  const { setOpenDrawer } = React.useContext(PortalContext)
  const [changeColor, setChangeColor] = React.useState(false)
  const location = useLocation()

  const getWeight = (url: string) => {
    return location.pathname === url ? 'bold' : 'regular'
  }

  const logoutAccount = () => {
    instance.logout()
  }

  const closeAllDrawers = () => {
    setOpenDrawer(false)
  }

  const hoverOverUsername = () => {
    setChangeColor(!changeColor)
  }

  const { instance, accounts } = useMsal()
  const username = accounts[0].username || ''
  const name = instance.getAccountByUsername(username)?.name
  const textColor = changeColor ? 'brand' : 'default'

  return (
    <nav className={styles.navigation}>
      <PFlex wrap='wrap' direction='column' justifyContent='space-between' className={styles.container}>
        <header className={styles.header}>
          <PMarque className={styles.brand} />
          <PHeadline variant='headline-3' align='center'>
            {TEXTS.PORTAL_NAME}
          </PHeadline>
          {ENV_LABEL && (
            <div className={styles.stager}>
              <div className={clsx(styles.stageSign, styles.dev)}>
                <PText color='notification-error' weight='semibold'>
                  {ENV_LABEL}
                </PText>
              </div>
            </div>
          )}
        </header>
        <main className={styles.content}>
          <ul className={styles.linkList}>
            <li className={styles.title}>
              <PHeadline variant='inherit' color='inherit' style={{ fontSize: '1.25rem', color: 'rgb(148, 148, 148)' }}>
                Verwaltung
              </PHeadline>
            </li>
            <li>
              <NavLink exact to='/' className={styles.link} activeClassName={styles.active} onClick={closeAllDrawers}>
                <PText weight={getWeight('/')}>Reporting</PText>
              </NavLink>
              <NavLink exact to='/applications' className={styles.link} activeClassName={styles.active}>
                <PText weight={getWeight('/applications')}>Meine Applikationen</PText>
              </NavLink>
            </li>
            <li className={styles.title}>
              <PHeadline variant='inherit' color='inherit' style={{ fontSize: '1.25rem', color: 'rgb(148, 148, 148)' }}>
                How-To
              </PHeadline>
            </li>
            <li>
              <NavLink
                to='/user-guide'
                className={styles.link}
                activeClassName={styles.active}
                onClick={closeAllDrawers}
              >
                <PText weight={getWeight('/user-guide')}>End User Guide</PText>
              </NavLink>
            </li>
            <li>
              <NavLink
                to='/url-guide'
                className={styles.link}
                activeClassName={styles.active}
                onClick={closeAllDrawers}
              >
                <PText weight={getWeight('/url-guide')}>Integration per URL</PText>
              </NavLink>
            </li>
            <li>
              <NavLink
                to='/api-guide'
                className={styles.link}
                activeClassName={styles.active}
                onClick={() => setOpenDrawer(false)}
              >
                <PText weight={getWeight('/api-guide')}>Integration per API</PText>
              </NavLink>
            </li>
          </ul>
        </main>
        <footer className={styles.footer}>
          <a
            onClick={logoutAccount}
            className={styles.logout}
            onMouseEnter={hoverOverUsername}
            onMouseLeave={hoverOverUsername}
          >
            <PText weight='semibold' color={textColor}>
              {name}
            </PText>
            <PText color={textColor}>abmelden</PText>
          </a>
        </footer>
      </PFlex>
    </nav>
  )
}
